import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { Node_Type } from 'ricos-schema';
import { Mark_Type } from 'ricos-types';

import type { Level } from '../title/extension';
import { HEADER_NAMES } from '../title/extension';

/**
 * This decoration adds either font size (which makes list markers and paddings to size)
 * or a data-heading-level attribute to list items,
 * based on which the list item gets heading styles.
 */
export const createListItemSizingDecorationPlugin = () => {
  return new Plugin({
    key: new PluginKey(`list-item-sizing`),
    props: {
      decorations: ({ doc }) => {
        const decorations: Decoration[] = [];
        doc.descendants((node, pos) => {
          if (node.type.name !== Node_Type.LIST_ITEM) {
            return;
          }

          // if list item's child's (paragraph's/heading's) first text node has a specified font-size,
          // it gets applied to the list item as a decorator to make list item marker the same font-size
          const firstChildOfListItem = node.firstChild;
          const childFontSize = firstChildOfListItem?.firstChild?.marks.find(
            mark => mark.type.name === Mark_Type.FONT_SIZE
          )?.attrs.value;
          if (childFontSize) {
            decorations.push(
              Decoration.node(pos, pos + node.nodeSize, {
                style: `font-size: ${childFontSize}px`,
              })
            );
          }

          if (firstChildOfListItem?.type.name === Node_Type.HEADING) {
            const headingLevel: Level = firstChildOfListItem?.attrs.level || 1;
            decorations.push(
              Decoration.node(pos, pos + node.nodeSize, {
                'data-heading-level': `header${HEADER_NAMES[headingLevel - 1]}`,
              })
            );
          }
        });
        return DecorationSet.create(doc, decorations);
      },
    },
  });
};
